import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer  } from '@angular/platform-browser';


@Pipe({
    name: 'domseguro',
    standalone: false
})
export class DomseguroPipe implements PipeTransform {

  constructor( private domSanitizer:DomSanitizer ){ }

  transform( direccion: any,): any {
    return this.domSanitizer.bypassSecurityTrustResourceUrl( "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3333.1423004993385!2d-33.3435176,-60.2686207!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95b767984ac2a3a3%3A0xf126c67ff4693dfc!2s"+direccion.calle+"%20"+direccion.numero+"%2C%20San%20Nicol%C3%A1s%20de%20Los%20Arroyos%2C%20Provincia%20de%20Buenos%20Aires!5e0!3m2!1ses-419!2sar!4v1619723718064!5m2!1ses-419!2sar" );
  }

}
